import Text from 'common/ui/Text';
import { Stack } from 'common/ui/Layout';
import { css } from 'styled-components';
import { Colors, Spacings } from 'styles';
import React from 'react';
import { HPDivider } from './hpStyles';
export interface MatchingDescriptionsTableProps {
  descriptions: readonly string[];
  backgroundColor?: string;
}

export const MatchingDescriptionsTable = ({ descriptions }: MatchingDescriptionsTableProps) => {
  return (
    <div
      css={css`
        height: 100%;
      `}
    >
      {descriptions.map((description, index) => (
        <React.Fragment key={index}>
          <Stack
            alignY="center"
            css={css`
              padding: ${Spacings.xsmall}rem 1rem;
            `}
          >
            <Text
              css={css`
                flex: 1;
                color: ${Colors.gray10};
                line-height: 32px;
              `}
              data-testid={`matching-description-${index}`}
            >
              {description}
            </Text>
          </Stack>
          {index < descriptions.length - 1 && <HPDivider />}
        </React.Fragment>
      ))}
    </div>
  );
};
